import React, { useEffect, useRef, useState } from 'react';
import ImageIcon from '@mui/icons-material/Image';
import imageCompression from 'browser-image-compression';

const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      const base64Puro = result//result.split(',')[1];
      resolve(base64Puro);
    };
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
};

interface Props {
  value?: string | null; // ahora el value es directamente Base64
  onChange?: (base64: string | null) => void;
}

const SingleImageUpload: React.FC<Props> = ({ value, onChange }) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  useEffect(() => {
    setPreviewUrl(value || null);
  }, [value]);

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    if (!file) {
      onChange?.(null);
      return;
    }

    try {
      const options = {
        maxSizeMB: 1, // Permite hasta 1 MB (reduce sin destruir calidad)
        maxWidthOrHeight: 1920, // Mantiene buena resolución
        initialQuality: 0.85, // Calidad alta (85%)
        useWebWorker: true,
      };

      const compressedFile = await imageCompression(file, options);

      /*console.log(
        `Original: ${(file.size / 1024 / 1024).toFixed(2)} MB → Comprimida: ${(compressedFile.size / 1024 / 1024).toFixed(2)} MB`
      );*/

      // 🔁 Convertir a Base64 después de comprimir
      const base64 = await fileToBase64(compressedFile);
      onChange?.(base64);
    } catch (error) {
      console.error('Error al comprimir la imagen:', error);
      onChange?.(null);
    }
  };

  const handleRemove = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (fileInputRef.current) fileInputRef.current.value = '';
    onChange?.(null);
  };

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <div
      className="position-relative border rounded text-center p-3"
      style={{ height: '180px', cursor: 'pointer', background: "white" }}
      onClick={handleClick}
    >
      {previewUrl ? (
        <>
          <button
            type="button"
            className="btn-close position-absolute top-0 end-0 m-2"
            aria-label="Eliminar"
            onClick={handleRemove}
          />
          <img
            src={previewUrl}
            alt="Vista previa"
            className="img-fluid h-100 object-fit-contain"
            style={{ maxHeight: '120px' }}
          />
        </>
      ) : (
        <div className="d-flex flex-column justify-content-center align-items-center h-100 text-secondary">
          <ImageIcon fontSize='large' style={{ fill: "#a5a5a5" }} />
          <span style={{ color: "#a5a5a5" }}>Agregar archivo</span>
        </div>
      )}
      <input
        type="file"
        accept="image/png, image/jpeg"
        ref={fileInputRef}
        className="d-none"
        onChange={handleFileChange}
      />
    </div>
  );
};

export default SingleImageUpload;
